<script>
  import { onMount } from "svelte";
  import fx from "../actions/fx.js";
  import { muted, abouted, drifter } from "../stores/global.js";

  let api;
  let closed = true;

  const toggleMute = () => {
    $muted = !$muted;
  };

  const toggleDrift = () => {
    if (api) {
      closed = !closed;
      if (closed) api.widget.hide();
      else {
        api.startInteraction({ interactionId: 283384 });
        api.widget.show();
        api.openChat();
        document.querySelector("#drift-frame-chat").style.right = "28px";
        document.querySelector("#drift-frame-chat").style.bottom = "70px";
      }
    }
  };

  onMount(() => {
    if ($drifter) {
      $drifter.load("e8i7a7kut4na");
      $drifter.on("ready", (a) => {
        api = a;
        setTimeout(() => {
          document.querySelector("#drift-frame-controller").style.display =
            "block";
        }, 2000);
        setTimeout(() => {
          api.widget.hide();
        }, 2017);
      });

      $drifter.on("chatClose", () => {
        if (api) api.widget.hide();
        closed = true;
      });
    }
  });
</script>

<div id="legal">
  <ul>
    <li><a href="https://www.siriusxmmedia.com/privacy">Privacy Policy</a></li>
    <li><a href="https://www.siriusxmmedia.com/terms">Terms</a></li>
    <li><button on:click="{toggleDrift}" use:fx>Resources</button></li>
    <li>
      <button on:click="{toggleMute}" use:fx
        >{$muted ? "Unmute" : "Mute"}</button
      >
    </li>
  </ul>
</div>

<style>
  ul {
    display: flex;
    list-style-type: none;
    position: absolute;
    bottom: 1em;
    right: 0;
    pointer-events: auto;
  }

  li {
    /* padding: 0 1em; */
    width: 5em;
    text-align: center;
  }

  a,
  a:visited,
  button {
    font-size: 14px;
    color: var(--base-gray-medium);
    text-decoration: underline;
    line-height: 1;
    padding: 0;
    display: inline-block;
    border: none;
    outline: none;
  }

  a:hover,
  button:hover {
    box-shadow: 0 0 4px 2px var(--theme);
  }

  li:last-of-type button {
    color: var(--base-gray-light);
  }

  @media only screen and (max-width: 1024px) {
    ul {
      flex-direction: column;
    }

    li {
      width: auto;
      text-align: right;
      padding-right: 1.5em;
    }
  }

  @media only screen and (max-width: 640px) {
    ul {
      width: 100%;
      right: auto;
      left: 50%;
      transform: translate(-50%, 0);
      justify-content: center;
    }

    ul {
      flex-direction: row;
      bottom: 0.5em;
    }

    li {
      width: 5em;
      text-align: center;
      padding: 0;
    }
  }
</style>
